import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { PaymentDerivedStatus } from '@fitness-force/enum';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BadgeModule } from 'primeng/badge';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'payment-timeline-status',
  templateUrl: './payment-timeline-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [BadgeModule, TranslateModule, AsyncPipe],
})
export class PaymentTimelineStatusComponent {
  translate = inject(TranslateService);

  additionData: Observable<any> = new BehaviorSubject(null);
  columnData: Observable<any> = new BehaviorSubject(null);

  public get paymentStatus() {
    return PaymentDerivedStatus;
  }

  isInProgress(timeline: any): boolean {
    return (
      timeline.payment_status === this.paymentStatus.Created ||
      timeline.payment_status?.toString() ===
        this.paymentStatus[this.paymentStatus.Created] ||
      timeline.payment_status == PaymentDerivedStatus.Initiated ||
      timeline.payment_status?.toString() ==
        PaymentDerivedStatus[PaymentDerivedStatus.Initiated]
    );
  }
}
